import { createSlice } from "@reduxjs/toolkit";
import { getDashboardData, getDashboardRecentActivity } from "./dashboardSlice";

const initialState = {
  loading: false,
  error: null,
  data: {},
  lists: {},
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* ---------------- Dashboard Data ---------------- */
      .addCase(getDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDashboardData.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        if (data?.subType) {
          state.data[data.subType] = data;
        }
      })
      .addCase(getDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      /* ---------------- Finance Only ---------------- */
      .addCase(getDashboardRecentActivity.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDashboardRecentActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.lists = action.payload.data;
      })
      .addCase(getDashboardRecentActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default dashboardSlice.reducer;
